// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bf-0";
export var headerCellHover = "_bf-1";
export var readCellContainer = "_bf-2";
export var readCellSlot = "_bf-3";
export var rowHoverCheckbox = "_bf-4";
export var rowUnreadIndicator = "_bf-5";
export var searchHighlight = "_bf-8";
export var supportTicketRow = "_bf-6";
export var unreadIndicator = "_bf-7";